// extracted by mini-css-extract-plugin
module.exports = {"inbox":"Inbox__inbox--3Nx","icon":"Inbox__icon--1AE"};